//声明变量，用于存储输入框的值。
import DataDict from '../../../static/js/DataDictJs'
var temp_th = "";
import Vue from 'vue'
function amount(th){
    var regStrs = [
        ['^0(\\d+)$', '$1'], //禁止录入整数部分两位以上，但首位为0
        ['[^\\d\\.]+$', ''], //禁止录入任何非数字和点
        ['\\.(\\d?)\\.+', '.$1'], //禁止录入两个以上的点
        ['^(\\d+\\.\\d{2}).+', '$1'] //禁止录入小数点后两位以上
    ];
    //如果获取不到输入框的值，则会将输入框上次的值赋值给它。以此解决数字输入时，如果输入两个小数点，会被清空内容的情况。
    if(th.value == ""){
        if (temp_th.length ==1) {
            th.value = "";
        }else if(temp_th.length ==2){
            th.value = "";
        }else{
            th.value = "";
        }
    }else{
        temp_th = th.value;
    }
    for(let i=0; i<regStrs.length; i++){
        var reg = new RegExp(regStrs[i][0]);
        // console.log(reg);
        th.value = th.value.replace(reg, regStrs[i][1]);
    }
}

//输入金额处理方法（保留小数点后两位，不足两位自动补全）
function formatMoney(th){
    var v = th.value;
    if(v == ''){
        v = '';
    }else if(v == '0'){
        v = '0.00';
    }else if(v == '0.'){
        v = '0.00';
    }else if(/^0+\d+\.?\d*.*$/.test(v)){
        v = v.replace(/^0+(\d+\.?\d*).*$/, '$1');
    }else if(/^0\.\d$/.test(v)){
        v = v + '0';
    }else if(!/^\d+\.\d{2}$/.test(v)){
        if(/^\d+\.\d{2}.+/.test(v)){
            v = v.replace(/^(\d+\.\d{2}).*$/, '$1');
        }else if(/^\d+$/.test(v)){
            v = v + '.00';
        }else if(/^\d+\.$/.test(v)){
            v = v + '00';
        }else if(/^\d+\.\d$/.test(v)){
            v = v + '0';
        }else if(/^[^\d]+\d+\.?\d*$/.test(v)){
            v = v.replace(/^[^\d]+(\d+\.?\d*)$/, '$1');
        }else if(/\d+/.test(v)){
            v = v.replace(/^[^\d]*(\d+\.?\d*).*$/, '$1');
            // ty = false;
        }else if(/^0+\d+\.?\d*$/.test(v)){
            v = v.replace(/^0+(\d+\.?\d*)$/, '$1');
            // ty = false;
        }else{
            v = '';
        }
    }
    th.value = v; 
    return th.value;
}

/*cj*/
//富文本模块最后提交时对img做处理
function submitUMDataStr(UMDataStr){
    let reg=new RegExp(commonUrl,'g');
    UMDataStr=UMDataStr.replace(reg,"");
    return UMDataStr;
};
//富文本数据回显
// function backShowDomAndUM(UMDataStr){
//     let reg=/src="/g;
//     let reg1=/src="https/g;
//     let reg2=/src="http/g;
//     if(UMDataStr){
//         if(!(UMDataStr.search(reg1) != -1) || !(UMDataStr.search(reg2) != -1)){
//             UMDataStr = UMDataStr.replace(reg,'src="'+commonUrl);
//         }
//     }
//     return UMDataStr;
// };
function backShowDomAndUM(UMDataStr){
    let reg=/src="/g;
    let reg1=/src="https|data:image/g;
    let reg2=/src="http|data:image/g;
    if(UMDataStr){
        if( !((UMDataStr.search(reg1) > -1) || (UMDataStr.search(reg2) > -1)) ){
            UMDataStr = UMDataStr.replace(reg,'src="'+commonUrl);
        }
    }
    return UMDataStr;
};

function getPageNav (ele){//页面对应左侧菜单
    var dataTit=$(ele).attr("data-tit");
    $(".el-menu[role='menu'] li").removeAttr('style');
    $(".el-menu[role='menu'] li:contains('"+dataTit+"')").addClass('is-active').siblings('li').removeClass('is-active');
}

function cloneObj(obj){
    var result={};
    for(var key in obj){
        result[key]=obj[key];
    }
    return result;
}

function hitAlert(msg){
  Vue.prototype.$alert(msg || "数据请求失败，请重试", '提示', {
    confirmButtonText: '确定',
    customClass:'hintSuecss',
  });
}

function WiseaIMUIFn (idType){
      let _this=this;
      if(window.loginToken){
        WiseaIMUI.createChat(idType);
        /*if(flagType=='1'){
            WiseaIMUI.createChat(idType);
        }else{
            $.ajax({
               type: "post"
               ,url: Action.SECURITY_W_IM_CUSTOMER_DISPATCH
               ,contentType:"application/json"
               ,data: JSON.stringify({"userId" : idType})
               ,beforeSend: function(jqXHR, settings){
                       jqXHR.setRequestHeader("Authorization", window.loginToken);
                   }
                ,success: function(res){
                  if(res){
                    if(res.code == "000"){
                      WiseaIMUI.createChat(res.result);
                    }else if(res.code=='916'){
                        hitAlert(res.msg);
                    }else {
                       hitAlert(res.msg);
                    }
                  }
                }
             });
        }*/
      }else{
        hitAlert("请登录");
      }
}


function intMoney(th){
    var reg_whole_number = /\D|^0/g;　//正整数 
    th.value = th.value.replace(reg_whole_number,'');
}


function intMoney100(th){
    var reg_whole_number = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;　//正整数 
    if (reg_whole_number.test(th.value)){
        console.log(1);
    }
    //th.value = th.value.replace(reg_whole_number,'');
    if(th.value>100){
        th.value=100;
    }
}

function int100(th){
    if(th.value){
        var reg_whole_number = /^0{1}$|^[1-9]{1,2}$|^[1-9]0{1,2}$/;　//正整数 
        var reg=/\D/g;

        if ( !(reg_whole_number.test(th.value)) ){
            th.value = th.value.replace(reg,'');
        }

        if( Number(th.value) > 100 ){
            th.value = 100;
        }

    }else{
        th.value="";
    }
}

function getUrl(){
    var objs={};
    var str=window.location.href;
    var num=str.indexOf("?");
    var newStr=str.substr(num+1);
    var strArr=newStr.split("&");
    var name;
    var val;
    for(var i=0;i<strArr.length;i++){
    var arrary=strArr[i].split("=");
    name=arrary[0];
    val=arrary[1];
    objs[name]=val;
    }
    return objs;
}

//提示信息
function confirmFun(id,message,callback) {
    var _this = new Vue({});
    _this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
        if(id instanceof Array) {
            callback(...id);
        } else {
            callback(id);
        }
    }).catch(() => {
      _this.$message({
        type: 'info',
        message: '已取消'
      });          
    });
}

//数据字典过滤器
function formatDict(type,val) {
  var val = $(window).DataStore().getDictLabel(type,val);
  return val;
};

//年月日时分秒转换为年月日
function formatDate(date) {
    var reg = /(\s\d{2}:\d{2}:\d{2})/g;
    date = date.replace(reg,'');
    return date;
}

// 对象深层复制
function cloneObjectFn (obj){ 
    var obj = obj || {};
    return JSON.parse(JSON.stringify(obj))
}


// 获取数据字典类型值
function getDictType(eve) {
	var tt = DataDict[eve];
	if (tt) {
		return tt;
	} else {
		return {};
	}
}

//获取数据字典label
function getDictLabel(eve, val) {
	var tt = DataDict[eve];
	if (tt) {
		for (var i = 0; i < tt.length; i++) {
			if (tt[i].value == val) {
				return tt[i].label;
			}
		}
	} else {
		return {};
	}
}

export {
    formatMoney,
    amount,
    getPageNav,
    cloneObj,
    intMoney,
    intMoney100,
    int100,
    WiseaIMUIFn,
    getUrl,
    submitUMDataStr,
    backShowDomAndUM,
    confirmFun,
    formatDict,
    formatDate,
    cloneObjectFn,
    getDictType,
    getDictLabel,
}


// WEBPACK FOOTER //
// ./src/assets/js/tool.js